import { Commands, Events, eventsManager, SceneConstants } from "@rhinov/savane-js";
import { ResourceWidget } from "./ResultsWidgets/ResourceWidget";
import { ResultsController } from "./Tools/ResultsController";
import { PlanManager, ActionStateEnum } from '@rhinov/cocos-plan'
import { _ASSET_TYPE, getResourcesPinboards } from "@rhinov/asset-manager-service";
import { DecorationService } from "../decorationService";

export class ResultsWidget {
    static controller: ResultsController;
    static loading: boolean = false;
    static destroyed: boolean = false;
    //Results datas
    static resources: any[] = [];
    static newResources: any[] = [];
    static currentPage: number = 1;
    static currentlyLoading: boolean = false;
    static lineCount: number = 2;
    static limit: number = 1;
    static tooltip: string | null = null;
    static tooltipProcess: any = null;
    //Data handle type drag (true) or click(false)
    static draggableEntities: boolean = true;

    /**
     * Current group of resource requested on arrangement manager
     */
    static currentGroup: string | null = null;

    //#region Drag and drop
    static draggedRes: any | null = null;
    static allArrangementObjects: any | null = null; //(typeof PlanManager === 'undefined') ? [] : PlanManager.getInstance().world.currentScene.arrangementObjects;
    static allCoatingObjects: any | null = null; //(typeof PlanManager === 'undefined') ? [] : PlanManager.getInstance().world.currentScene.coatings;
    static allGroupObjects: any | null = null; //(typeof PlanManager === 'undefined') ? [] : PlanManager.getInstance().world.currentScene.arrangementGroups;
    static onDragAsset: Function | null = null;
    //#endregion

    static requestAMStartTime: number;

    //#region External Values
    static checkFullscreenCallback: Function;
    static designer: any | undefined;
    static openDetailsFunc?: (url: string) => void;
    static currentResource: any;
    static parentId: string;
    //#endregion

    //#region CSS Variables
    //TWEAK VALUE TO HANDLE FLEX LINES
    static FLEX_OFFSET = 0;
    static MARGIN_ITEM = 1;
    static itemSize = 80;
    static itemCount = 0;
    static displaySize: number = 2;
    //#endregion

    //#region Listener for filter update
    static filtersListener: any;
    static projectLoaded: any;
    static projectUpdated: any;
    static reloadListener: any;
    static componentAddedListener: any;
    static componentRemovedListener: any;
    static commandListener: any;
    static resizeListener: any;
    static fullscreenListener: any;
    static tabChangeListener: any;
    static selectionListener: any;
    //#endregion

    static handleEntityAdded(id: string) {
        let checkmark = $('#checkmark-' + id);
        if (!checkmark[0]) return;
        checkmark.css('display', '');
    }

    static handleEntityRemoved(id: string) {
        let checkmark = $('#checkmark-' + id);
        if (!checkmark[0]) return;
        checkmark.css('display', 'none');
    }

    static getDecorationService() {
        return DecorationService.getInstance();
    }

    static resizeToolBar() {
        const height = ResultsWidget.getToolBarHeight();
        $('#top-part').css('height', height + '%');
    }

    static getToolBarHeight() {
        if (ResultsWidget.isWorktopMode()) {
            const height = $('#designerMain').height();
            if (height === undefined) return 0;
            return 122 * 100 / height;
        } else {
            var itemSize = 82;
            if (!!document.fullscreenElement) {
                if (ResultsWidget.displaySize === 2) {
                    itemSize = 122;
                }
            }
            const height = $('#designerMain').height();
            if (height === undefined) return 0;
            return ((itemSize * ResultsWidget.displaySize) + 24) * 100 / height;
        }
    };

    static isWorktopMode() {
        var instance = PlanManager.getInstance();

        if (instance !== null && instance !== undefined) {
            return instance.getAction() === ActionStateEnum.DrawWorkTop;
        }
    };


    static removeDuplicates(idList: string[]): string[] {
        const uniqueIds: string[] = [];
        idList.forEach((id) => {
            if (!uniqueIds.includes(id)) {
                uniqueIds.push(id);
            }
        });
        return uniqueIds;
    }

    static start(parentId: string, checkFullscreenCallback: Function, designer?: any, openDetailsFunc?: (url: string) => void): ResultsWidget {
        ResultsWidget.destroyed = false;
        ResultsWidget.controller = new ResultsController();
        ResultsWidget.parentId = parentId;
        ResultsWidget.designer = designer;
        ResultsWidget.checkFullscreenCallback = checkFullscreenCallback;
        ResultsWidget.openDetailsFunc = openDetailsFunc;

        ResultsWidget.setDisplaySize(ResultsWidget.displaySize);
        ResultsWidget.resizeListener = $(window).on('resize' as any, ResultsWidget.resizeFunc);
        const decorService = ResultsWidget.getDecorationService();
        if (decorService) {
            ResultsWidget.filtersListener = eventsManager.instance.addListener(decorService.FILTERS_CHANGE, ResultsWidget.renewRequest.bind(this));
        }

        ResultsWidget.projectLoaded = eventsManager.instance.addListener(Events.PROJECT_DID_LOAD, ResultsWidget.refreshArrangementObjectList);
        ResultsWidget.projectUpdated = eventsManager.instance.addListener(Events.UPDATE_RHINOV_FORMAT, ResultsWidget.refreshArrangementObjectList);
        ResultsWidget.reloadListener = eventsManager.instance.addListener(Events.PROJECT_RELOAD, ResultsWidget.refreshArrangementObjectList);
        ResultsWidget.componentAddedListener = eventsManager.instance.addListener(Events.COMPONENT_ADDED, ResultsWidget.refreshArrangementObjectList);
        ResultsWidget.componentRemovedListener = eventsManager.instance.addListener(Events.COMPONENT_REMOVED, ResultsWidget.refreshArrangementObjectList);
        ResultsWidget.commandListener = eventsManager.instance.addListener(Events.COMMAND_EXECUTED, function (event: any) {
            // Depending on the command name (see Command.js from CocosPlanModule/src/cocos/scripts/command)
            switch (event.userData.name) {
                case Commands.CommandEnum.AddEntityCommand:
                case Commands.CommandEnum.DeleteEntityCommand:
                    if (event.userData.name === Commands.CommandEnum.AddEntityCommand) {
                        if (event.userData.undo) {
                            ResultsWidget.handleEntityRemoved(event.userData.datas.entity._objectId);
                        } else {
                            ResultsWidget.handleEntityAdded(event.userData.datas.entity._objectId);
                        }
                    } else {
                        if (event.userData.undo) {
                            ResultsWidget.handleEntityAdded(event.userData.datas.entity._objectId);
                        } else {
                            ResultsWidget.handleEntityRemoved(event.userData.datas.entity._objectId);
                        }
                    }
                    if (event.userData.datas.type === SceneConstants.EntityType.ArrangementObject || event.userData.datas.type === SceneConstants.EntityType.ArrangementGroup) {
                        const instance = PlanManager.getInstance();
                        if (instance.world?.currentScene) {
                            ResultsWidget.allArrangementObjects = instance.world.currentScene.arrangementObjects;
                            ResultsWidget.allGroupObjects = instance.world.currentScene.arrangementGroups;
                            ResultsWidget.showUsedUpdated();
                        }
                    }
                    break;

                case Commands.CommandEnum.DeleteGroupCommand:
                    if (event.userData.undo) {
                        ResultsWidget.handleEntityAdded(event.userData.datas.group._objectId);
                    } else {
                        ResultsWidget.handleEntityRemoved(event.userData.datas.group._objectId);
                    }
                    ResultsWidget.handleEntityRemoved(event.userData.datas.group._objectId);
                    const instance2 = PlanManager.getInstance();
                    if (instance2.world?.currentScene) {
                        ResultsWidget.allGroupObjects = instance2.world.currentScene.arrangementGroups;
                        ResultsWidget.showUsedUpdated();
                    }
                    break;

                case Commands.CommandEnum.ChangeCoatingCommand:
                case Commands.CommandEnum.DeleteComponentCommand:
                    const instance3 = PlanManager.getInstance();
                    let newCoatingObjects: any[] = instance3.world?.currentScene?.coatings || [];
                    const newListIds = ResultsWidget.removeDuplicates(newCoatingObjects.map((obj: any) => obj._coatingId));
                    let oldListIds: any[];

                    if (ResultsWidget.allCoatingObjects !== null && ResultsWidget.allCoatingObjects !== undefined) {
                        oldListIds = ResultsWidget.allCoatingObjects.map((obj: any) => obj._coatingId);
                    } else oldListIds = [];
                    oldListIds = ResultsWidget.removeDuplicates(oldListIds);
                    if (event.userData.datas.component._coatingId !== undefined) {
                        if (event.userData.name === Commands.CommandEnum.ChangeCoatingCommand) {
                            if (event.userData.undo) {
                                if (oldListIds.length > newListIds.length) {
                                    const removed = oldListIds.filter((id) => !newListIds.includes(id));
                                    console.log('removed', removed);
                                    removed.forEach((id) => ResultsWidget.handleEntityRemoved(id));
                                } else if (oldListIds.length < newListIds.length) {
                                    const added = newListIds.filter((id) => !oldListIds.includes(id));
                                    console.log('added', added);
                                    added.forEach((id) => ResultsWidget.handleEntityAdded(id));
                                }
                            } else {
                                ResultsWidget.handleEntityAdded(event.userData.datas.component._coatingId);
                                const removed = oldListIds.filter((id) => !newListIds.includes(id));
                                console.log('removed', removed);
                                removed.forEach((id) => ResultsWidget.handleEntityRemoved(id));
                            }
                        } else {
                            ResultsWidget.handleEntityRemoved(event.userData.datas.component._coatingId);
                        }
                    }
                    ResultsWidget.allCoatingObjects = newCoatingObjects;
                    ResultsWidget.showUsedUpdated();
                    break;
            }
        });
        ResultsWidget.fullscreenListener = eventsManager.instance.addListener(Events.FULLSCREEN_CHANGED, function (event: any) {
            if (event.userData === true) {
                ResultsWidget.setDisplaySize(3);
            } else {
                ResultsWidget.setDisplaySize(2);
            }
        });
        const decorService2 = ResultsWidget.getDecorationService();
        if (decorService2) {
            ResultsWidget.tabChangeListener = eventsManager.instance.addListener(decorService2.FILTERS_TAB_CHANGED, () => ResultsWidget.updateCheckboxToolsHtml());
        }
        ResultsWidget.selectionListener = eventsManager.instance.addListener(Events.SELECTION_CHANGED, () => {
        });
        $('#' + ResultsWidget.parentId).addClass('FilterView_DefaultConf'); //Add class to handle default size

        ResultsWidget.html();
        return new ResultsWidget();
    }


    static destroy(): void {
        if (ResultsWidget.destroyed) return;
        ResourceWidget.destroy();
        if (ResultsWidget.controller) {
            ResultsWidget.controller.destroy();
        }
        (ResultsWidget.controller as any) = null;
        eventsManager.instance.removeListener(ResultsWidget.filtersListener);
        ResultsWidget.filtersListener = null;
        eventsManager.instance.removeListener(ResultsWidget.projectLoaded);
        ResultsWidget.projectLoaded = null;
        eventsManager.instance.removeListener(ResultsWidget.projectUpdated);
        ResultsWidget.projectUpdated = null;
        eventsManager.instance.removeListener(ResultsWidget.reloadListener);
        ResultsWidget.reloadListener = null;
        eventsManager.instance.removeListener(ResultsWidget.componentAddedListener);
        ResultsWidget.componentAddedListener = null;
        eventsManager.instance.removeListener(ResultsWidget.componentRemovedListener);
        ResultsWidget.componentRemovedListener = null;
        eventsManager.instance.removeListener(ResultsWidget.fullscreenListener);
        ResultsWidget.fullscreenListener = null;
        eventsManager.instance.removeListener(ResultsWidget.commandListener);
        ResultsWidget.commandListener = null;
        eventsManager.instance.removeListener(ResultsWidget.tabChangeListener);
        ResultsWidget.tabChangeListener = null;
        eventsManager.instance.removeListener(ResultsWidget.selectionListener);
        ResultsWidget.selectionListener = null;
        $(window).off('resize', ResultsWidget.resizeListener);
        ResultsWidget.destroyed = true;
    }

    static refreshArrangementObjectList() {
        if (typeof PlanManager === 'undefined') {
            return;
        }

        const instance = PlanManager.getInstance();
        if (!instance.world?.currentScene) return;
        ResultsWidget.allArrangementObjects = instance.world!.currentScene.arrangementObjects;
        ResultsWidget.allCoatingObjects = instance.world!.currentScene.coatings;
        ResultsWidget.allGroupObjects = instance.world!.currentScene.arrangementGroups;
    };

    static tabId() {
        return ResultsWidget.getDecorationService()?.tabId;
    };

    static hideDragAndDropThumbnail() {
        $('.ui-draggable-dragging').css('display', 'none');
    }

    static cancelDrop(_event: any) {
        ResultsWidget.hideDragAndDropThumbnail();
        ResultsWidget.draggedRes = null;
    }

    static isDefined(value: any) {
        return typeof value !== 'undefined';
    }

    static showUsed(value?: any) {
        const decorService = ResultsWidget.getDecorationService();
        if (!decorService) return;
        if (ResultsWidget.isDefined(value)) {
            decorService.usedInProject = value;
        } else {
            return decorService.usedInProject;
        }
    };

    static scrollFunc() {
        // remove html tooltip if it exist to avoid crappy display
        $('#resourcesBar').find('.assetTooltip').remove();

        if (ResultsWidget.currentPage <= 1 || ResultsWidget.currentlyLoading || $('#resultsList')[0] === undefined) {
            return;
        }

        var scrollTop = $('#resultsList')[0].scrollTop;
        var scrollHeight = $('#resultsList')[0].scrollHeight;

        if (scrollHeight - (scrollTop + ResultsWidget.lineCount * (ResultsWidget.itemSize + (2 * ResultsWidget.MARGIN_ITEM))) < ResultsWidget.lineCount * (ResultsWidget.itemSize + (2 * ResultsWidget.MARGIN_ITEM))) {
            ResultsWidget.loadNextPage();
        }
    };

    static hideTooltip() {
        if (ResultsWidget.tooltipProcess !== null) {
            clearTimeout(ResultsWidget.tooltipProcess);
            ResultsWidget.tooltipProcess = null;
        }
        if (ResultsWidget.tooltip !== null) {
            //remove html
            $('#resourcesBar').find('.assetTooltip').remove();
        }
        ResultsWidget.tooltip = null;
    };

    /**
    * Launch a new fresh request
    */
    static renewRequest() {
        //Renew attributes for request
        ResultsWidget.limit = 0;
        ResultsWidget.currentPage = 1;
        ResultsWidget.resources = [];
        //Launch the new request
        setTimeout(() => {
            if (!$('#' + ResultsWidget.parentId)[0]) return;
            ResultsWidget.loadResources(ResultsWidget.lineCount * 3).then(_ => ResultsWidget.updateResourcesContainerHtml());
        }, 0);
    };

    static resizeFunc(noReload?: boolean) {
        var resourcesBarHeight = ((ResultsWidget.itemSize + (2 * ResultsWidget.MARGIN_ITEM)) * ResultsWidget.lineCount);
        $('#resultsList').css('height', resourcesBarHeight + 'px');
        $('#fountainG').css('height', resourcesBarHeight + 'px');
        if (!noReload && ResultsWidget.resources !== null && ResultsWidget.resources.length > 0) {
            ResultsWidget.renewRequest();
        }
        ResultsWidget.resizeToolBar();
    };

    static showUsedUpdated(toggle?: boolean) {
        const decorService = ResultsWidget.getDecorationService();
        if (!decorService) return;
        if (decorService.usedInProject) {
            var items: any[] = [];
            const instance = PlanManager.getInstance();
            switch (decorService.group) {
                case _ASSET_TYPE.ARRANGEMENTS:
                case _ASSET_TYPE.PRODUCTS:
                    if (ResultsWidget.allArrangementObjects === null) {
                        if (instance.world?.currentScene) {
                            ResultsWidget.allArrangementObjects = instance.world.currentScene.arrangementObjects;
                        }
                    }
                    if (ResultsWidget.allArrangementObjects) {
                        for (var i = 0; i < ResultsWidget.allArrangementObjects.length; ++i) {
                            const id = ResultsWidget.allArrangementObjects[i].objectId;
                            if (!items.includes(id)) {
                                items.push(id);
                            }
                        }
                    }
                    break;
                case _ASSET_TYPE.COATINGS:
                    if (ResultsWidget.allCoatingObjects === null) {
                        if (instance.world?.currentScene) {
                            ResultsWidget.allCoatingObjects = instance.world.currentScene.coatings;
                        }
                    }
                    if (ResultsWidget.allCoatingObjects) {
                        for (var i = 0; i < ResultsWidget.allCoatingObjects.length; ++i) {
                            const id = ResultsWidget.allCoatingObjects[i].coatingId;
                            if (!items.includes(id)) {
                                items.push(id);
                            }
                        }
                    }
                    break;
                case _ASSET_TYPE.TEMPLATES:
                    if (ResultsWidget.allGroupObjects === null) {
                        if (instance.world?.currentScene) {
                            ResultsWidget.allGroupObjects = instance.world.currentScene.arrangementGroups;
                        }
                    }
                    if (ResultsWidget.allGroupObjects) {
                        for (var i = 0; i < ResultsWidget.allGroupObjects.length; ++i) {
                            const id = ResultsWidget.allGroupObjects[i]._objectId;
                            if (!items.includes(id)) {
                                items.push(id);
                            }
                        }
                    }
                    break;
            }
            if (items.length > 0) {
                var filters = '&q._id.in=' + items;
                decorService.setFilters(decorService.group, filters);
            }
        } else {
            if (toggle) {
                decorService.setFilters(decorService.group, decorService.cacheFilters);
            }
        }
    };

    static displayGroups(value?: any) {
        const decorService = ResultsWidget.getDecorationService();
        if (!decorService) return;
        if (ResultsWidget.isDefined(value)) {
            decorService.displayGroups = value;
        } else {
            return decorService.displayGroups;
        }
    };

    static displayGroupsUpdated() {
        eventsManager.instance.dispatch(Events.TOGGLE_DISPLAY_GROUPS);
    };

    static loadNextPage() {
        ResultsWidget.currentPage++;
        ResultsWidget.limit = 0;
        ResultsWidget.loadResources(ResultsWidget.lineCount).then(_ => ResultsWidget.updateResourcesContainerHtml());
    };

    static generateDimensionsString(resource: any) {
        var dimString = '';
        var length = 0;
        var height = 0;
        var width = 0;

        if (resource.dimensions !== undefined && resource.dimensions !== null) {
            if (resource.sketchBlock !== undefined && resource.sketchBlock !== null) {
                //Use standard dimensions of sketchBlock
                if (resource.sketchBlock.dimensions) {
                    length = resource.sketchBlock.dimensions.length / 10;
                    length = parseInt(length.toFixed(2));
                    height = resource.sketchBlock.dimensions.height / 10;
                    height = parseInt(height.toFixed(2));
                    width = resource.sketchBlock.dimensions.width / 10;
                    width = parseInt(width.toFixed(2));
                }
                dimString += 'L' + width + ' x H' + height + ' x P' + length;
            }
            else {
                length = resource.dimensions.length / 10;
                length = parseInt(length.toFixed(2));
                height = resource.dimensions.height / 10;
                height = parseInt(height.toFixed(2));
                width = resource.dimensions.width / 10;
                width = parseInt(width.toFixed(2));
                dimString += 'L' + width + ' x H' + height + ' x P' + length;
            }
        }
        else {
            if (resource.displayDimensions !== undefined && resource.displayDimensions !== null) {
                length = resource.displayDimensions.length / 10;
                height = resource.displayDimensions.height / 10;
                width = resource.displayDimensions.width / 10;

                if (length !== 0 || height !== 0 || width !== 0) {
                    length = parseInt(length.toFixed(2));
                    height = parseInt(height.toFixed(2));
                    width = parseInt(width.toFixed(2));

                    dimString += 'L' + width + ' x H' + height + ' x P' + length;
                }
            }
        }
        return dimString;
    };

    static generatePriceString(resource: any) {
        var priceString = '';
        if (resource.price !== undefined && resource.price.value !== undefined) {
            priceString = '' + resource.price.value;
            if (resource.price.currency !== undefined) {
                if (resource.price.currency === 'EUR') {
                    priceString += '€';
                }
                if (resource.price.currency === 'GBP') {
                    priceString += '£';
                }
                if (resource.price.currency === 'USD') {
                    priceString += '$';
                }
            }
        }
        return priceString;
    };

    static generateQuantityString(resource: any) {
        if (!resource.stockInfo) {
            return ("(Informations de stocks non disponibles)");
        }

        var quantity = 0;
        if (resource.stockInfo.currentStockENT) {
            quantity = resource.stockInfo.currentStockENT;
        }
        var quantitySoon = 0;
        if (resource.stockInfo.forecastStockENT) {
            quantitySoon = resource.stockInfo.forecastStockENT;
        }

        return (" (" + quantity + " ex. disponibles aujourd'hui<br>" + quantitySoon + " ex. prévus à date prévisionnelle du projet)");
    };

    static generateDetailsString(resource: any) {
        let details = [];

        if (resource.isNewProduct) {
            details.push("Nouveauté");
        }
        if (resource.marketStatus === 'top') {
            details.push("Top ventes");
        }
        if (resource.marketStatus === 'flop' && !resource.isNewProduct) {
            details.push("Flop ventes");
        }
        if (resource.marketStatus === 'noos') {
            details.push("Haute dispo");
        }
        if (resource.saleState === 'on_sale') {
            details.push("En solde");
        }
        return (details.join(" - "));
    };

    static loadResources(nbLines: number) {
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        //Retrieve limit from element size
        var elemSize = ResultsWidget.itemSize + (2 * ResultsWidget.MARGIN_ITEM);
        var width = $('#' + ResultsWidget.parentId)[0].clientWidth - 18;
        var nbElementPerLine = Math.floor(width / elemSize);
        var limit = nbElementPerLine * nbLines;

        if (limit <= 0) {
            return new Promise<void>((resolve) => resolve());
        }

        if (ResultsWidget.currentPage === 1) {
            ResultsWidget.loading = true; // Set the loading state
        }
        ResultsWidget.currentlyLoading = true;
        ResultsWidget.updateResourcesContainerHtml();
        const decorService3 = ResultsWidget.getDecorationService();
        if (!decorService3) return new Promise<void>((resolve) => resolve());
        ResultsWidget.currentGroup = decorService3.group;

        if (ResultsWidget.currentGroup === "allAssets" && decorService3.tabId === "style" && decorService3.displayGroups === false) {
            limit = 512;
        }

        // Bench AM request
        ResultsWidget.requestAMStartTime = new Date().getTime();

        let promise = new Promise<void>((resolve) => {
            const decorService4 = ResultsWidget.getDecorationService();
            if (!decorService4) {
                resolve();
                return;
            }
            decorService4.loadResources(ResultsWidget.currentPage, limit, function (data: any, _url: any) {
                // Bench AM request
                var deltaTime = new Date().getTime() - ResultsWidget.requestAMStartTime;

                // Request valid
                if (deltaTime >= 0) {
                    // If the plan manager is around only
                    if (typeof PlanManager !== 'undefined') {
                        var world = PlanManager.getInstance().world;

                        // Accumulate AM requests and duration
                        world._nbAMRequests++;
                        world._totalTimeAMRequests += deltaTime;
                        if (world._minTimeAMRequests > deltaTime) {
                            world._minTimeAMRequests = deltaTime;
                        }
                        if (world._maxTimeAMRequests < deltaTime) {
                            world._maxTimeAMRequests = deltaTime;
                        }
                    }
                }

                ResultsWidget.loading = false; //End loading state
                ResultsWidget.currentlyLoading = false;
                if (data === null) {
                    if (ResultsWidget.currentPage === 1) {
                        ResultsWidget.resources = [];
                    }
                    resolve();
                }
                else {
                    ResultsWidget.limit = limit;

                    // Get asset issues here
                    var idsStr = '';

                    for (var i = 0; i < data.resources.length; i++) {
                        idsStr += data.resources[i]._id;
                        if (i < data.resources.length - 1) {
                            idsStr += ',';
                        }
                    }

                    // launch AM call here to get issues of the current resources array
                    ResultsWidget.getDecorationService()?.getResourcesIssues(idsStr).then((issueData: any) => {
                        if (issueData && issueData.resources) {
                            const current = data.resources.map((res: any, idx: any) => { return { id: res._id, index: idx } });
                            const incoming = issueData.resources.map((res: any) => { return { id: res.asset._id, hasIssues: true } });
                            const withIssues = current.filter((res: any) => incoming.some((inc: any) => inc.id === res.id));

                            for (let i = 0; i < withIssues.length; i++) {
                                data.resources[withIssues[i].index].hasIssues = true;
                            }
                        }

                        // launch AM call here to get pinboards of the current resources array
                        if (ResultsWidget.designer) {
                            getResourcesPinboards(idsStr, ResultsWidget.designer.mail, function (pinboardData: any) {
                                if (pinboardData && pinboardData.resources) {
                                    for (var i = 0; i < pinboardData.resources.length; i++) {
                                        var pinboard = pinboardData.resources[i];
                                        for (var j = 0; j < pinboard.items.length; ++j) {
                                            for (var k = 0; k < data.resources.length; k++) {
                                                if (data.resources[k]._id === pinboard.items[j]) {
                                                    data.resources[k].pinboard = true;
                                                }
                                            }
                                        }

                                    }
                                }
                                if (ResultsWidget.currentPage === 1) {
                                    ResultsWidget.resources = data.resources;
                                    ResultsWidget.currentPage = Math.ceil(data.resources.length / (nbElementPerLine * ResultsWidget.lineCount));
                                } else {
                                    ResultsWidget.newResources = data.resources;
                                }
                                resolve();
                            });
                        } else {
                            if (ResultsWidget.currentPage === 1) {
                                ResultsWidget.resources = data.resources;
                                ResultsWidget.currentPage = Math.ceil(data.resources.length / (nbElementPerLine * ResultsWidget.lineCount));
                            } else {
                                ResultsWidget.newResources = data.resources;
                            }
                            resolve();
                        }
                    });
                }
            });
        });
        return promise;
    };

    static outDrop() {
        ResultsWidget.hideDragAndDropThumbnail();
        if (ResultsWidget.draggedRes !== null) {
            if (typeof ResultsWidget.onDragAsset === 'function') {
                ResultsWidget.onDragAsset(ResultsWidget.draggedRes);
            } else {
                const decorService = ResultsWidget.getDecorationService();
                if (decorService) {
                    decorService.setAsset(ResultsWidget.draggedRes);
                }
            }
            ResultsWidget.draggedRes = null;
        }
    };

    static startDrag(res: any) {
        if (!ResultsWidget.draggedRes) {
            ResultsWidget.draggedRes = res;
            eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        }
    };

    /**
     * Display a tooltip containing information about the item
     **/
    static displayTooltip(resource: any, event: MouseEvent) {
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        if (ResultsWidget.tooltip === null) {
            if (ResultsWidget.tooltipProcess !== null) {
                clearTimeout(ResultsWidget.tooltipProcess);
                ResultsWidget.tooltipProcess = null;
            }
            ResultsWidget.tooltipProcess = setTimeout(function (event: MouseEvent) {
                //Prevent element to going out of screen (only laterally)
                let elements = document.querySelectorAll(`.listResults-${resource._id}`);
                if (!elements || elements.length === 0 || !$('#resourcesBar')[0]) return;
                let closest: Element = elements.item(0)!;
                if (elements.length !== 1) {
                    const clientX = event.clientX;
                    const clientY = event.clientY;
                    elements.forEach((elem) => {
                        if (!closest) { closest = elem; return; }
                        const elemBounds = elem.getBoundingClientRect();
                        const latestBounds = closest.getBoundingClientRect();
                        let latestDif = Math.abs(latestBounds.x - clientX) + Math.abs(latestBounds.y - clientY);
                        let currentDif = Math.abs(elemBounds.x - clientX) + Math.abs(elemBounds.y - clientY);
                        closest = Math.min(latestDif, currentDif) === latestDif ? closest : elem;
                    })
                }

                const $parent = $(closest);
                const parentOffset = $parent.offset();
                const parentHeight = $parent.height() ?? 0;
                const parentWidth = $parent.width() ?? 0;
                const vWidth = $(window).width() ?? 0;
                const resourcesBarOffset = $('#resourcesBar').offset();

                let top = (parentOffset?.top ?? 0) - (resourcesBarOffset?.top ?? 0) + parentHeight + 4;
                let left = (parentOffset?.left ?? 0) + (parentWidth - 180) / 2;

                if (left + 180 > vWidth) {
                    left = vWidth - 180;
                }
                if (left < 0) {
                    left = 0;
                }
                var imgUrl = $parent.css('backgroundImage') ?? '';
                imgUrl = imgUrl.replace('url(', '').replace(')', '').replace(/\"/gi, '');
                var resName = resource.name !== '' && resource.name !== undefined ? resource.name : (resource.genericName ? resource.genericName : resource.marketName);
                const resDetails = ResultsWidget.generateDetailsString(resource);
                var html = `
                    <div id="${resource.name}" class="assetTooltip" style="z-index:2000;top:${top}px;left:${left}px; pointer-events: none;">
                        <div class="res-name" style="font-size:12px">${resName}</div>
                        <div class="res-img" style="background-image:url(${imgUrl});border:1px solid #dddddd;background-position:50% 50%;background-size:cover;"></div>
                        <div class="res-dim" style="font-size:12px">${ResultsWidget.generateDimensionsString(resource)}</div>
                        <div class="res-price" style="font-size:12px">${ResultsWidget.generatePriceString(resource)}</div>
                        <div class="res-price" style="font-size:12px">${ResultsWidget.generateQuantityString(resource)}</div>
                        <div class="res-details" style="font-size:12px${resDetails === '' ? ";display:none" : ""}">${resDetails}</div>
                    </div>
                `;
                $('#resourcesBar').append(html);

                ResultsWidget.tooltip = '#' + resource.name;
                ResultsWidget.tooltipProcess = null;
            }.bind(this, event), 200);
        }
    };

    static setDisplaySize(size: number) {
        if (this.checkFullscreenCallback()) {
            ResultsWidget.displaySize = size;
            ResultsWidget.lineCount = size;
            if (size === 2) {
                ResultsWidget.itemSize = 120;
            } else {
                ResultsWidget.itemSize = 80;
            }
        } else {
            ResultsWidget.itemSize = 80;
            ResultsWidget.displaySize = size;
            ResultsWidget.lineCount = size;
        }
        ResultsWidget.resizeFunc();
        setTimeout(function () {
            eventsManager.instance.dispatch('display_size_changed', ResultsWidget.displaySize);
        });
    };

    static html(delta: number = 0): void {
        if (!$('#' + ResultsWidget.parentId)[0]) {
            if (delta >= 250) {
                console.error('Impossible de charger le widget de résultats');
                return;
            };
            // If the parentId is not found, try again after a delay
            setTimeout(() => {
                ResultsWidget.controller.destroy();
                ResultsWidget.html(delta + 50);
            });
            return;
        }
        let html = `
        <!-- RESOURCES -->
        <div id="resourcesBar" style="user-select:none">
            <!-- Add support for mouse wheel up and down here for the asset manager results for productivity purposes -->
            <div class="resourcesContainer" style="display: flex;flex-direction:column;justify-content: space-between;align-items: center">
                ${ResultsWidget.getResourcesContainerHtml()}
            </div>
        </div>
        `;
        $('#' + ResultsWidget.parentId)[0].innerHTML = html;
        setTimeout(() => {
            if (!ResultsWidget.controller) {
                return;
            }
            var resourcesBarHeight = ((ResultsWidget.itemSize + (2 * ResultsWidget.MARGIN_ITEM)) * ResultsWidget.lineCount);
            $('#resultsList').css('height', resourcesBarHeight + 'px');
            $('#fountainG').css('height', resourcesBarHeight + 'px');

            ($('#resourcesBar') as any).droppable({
                out: ResultsWidget.outDrop
            });

            ResultsWidget.controller.addEventListener('mouseleave', () => {
                ResultsWidget.outDrop();
                ResultsWidget.hideDragAndDropThumbnail();
            }, 'resourcesBar', undefined, true);

            ResultsWidget.controller.addEventListener('mouseenter', () => {
                ResultsWidget.hideDragAndDropThumbnail();
            }, 'resourcesBar', undefined, true);

            ResultsWidget.controller.addEventListener('mouseup', (evt) => {
                ResultsWidget.cancelDrop(evt);
            }, 'resourcesBar', undefined, true);

            //Say hello to filters
            const decorService5 = ResultsWidget.getDecorationService();
            if (decorService5) {
                eventsManager.instance.dispatch(decorService5.ASK_FILTERS, null);
            }
        });
    }

    static updateResourcesContainerHtml(): void {
        if (ResultsWidget.loading) {
            ResourceWidget.removeListeners(ResultsWidget.resources);
            $('#resultsList').html('');
            $('#resultsList').css('display', 'none');
            $('#loadingText').css('display', 'flex');
        } else {
            if (!ResultsWidget.resources || ResultsWidget.resources.length <= 0) {
                $('#resultsList').html('Aucun résultat');
                $('#loadingText').css('display', 'none');
                $('#resultsList').css('display', 'flex');
                return;
            }
            $('#loadingText').css('display', 'none');
            $('#resultsList').css('display', 'flex');
            if (ResultsWidget.newResources.length <= 0) {
                if ($('.resourceItem').length <= 0) {
                    ResourceWidget.removeListeners(ResultsWidget.resources);
                    $('#resultsList').html(ResourceWidget.html(ResultsWidget.resources));
                }
                return;
            };
            let newHtml = ResourceWidget.html(ResultsWidget.newResources);
            ResultsWidget.resources = ResultsWidget.resources.concat(ResultsWidget.newResources);
            ResultsWidget.newResources = [];
            $('#resultsList').append(newHtml);
        }
    }

    static getResourcesContainerHtml(): string {
        setTimeout(() => {
            if (!ResultsWidget.controller) {
                return;
            }
            ResultsWidget.resizeFunc(true);
            ResultsWidget.controller.addEventListener('scroll', () => {
                ResultsWidget.scrollFunc();
            }, 'resultsList', undefined, true);
        });
        return `
            ${ResultsWidget.getFountainGHtml()}
            <!--Item List-->
            <div id="resultsList" style="overflow:auto;${!ResultsWidget.loading ? 'display:flex' : 'display:none'}">
            ${ResultsWidget.resources && ResultsWidget.resources.length > 0 ? `
                ${ResourceWidget.html(ResultsWidget.resources)}
            `: 'Aucun résultat'}
            </div>
            
            <div style="display:flex;background:none;height:24px;background-color: #efefef;padding: 0 10px; width:100%">
                <div id="checkboxTools" style="display:contents;">
                    ${ResultsWidget.getUsedAssetsHtml()}
                    ${ResultsWidget.getGroupsHtml()}
                </div>
                <div id="result-size-mgr">
                    ${ResultsWidget.getResultSizeMgrHtml()}
                </div>
            </div>
        `;
    }

    static getFountainGHtml(): string {
        return `
            <!--Loading css-->
            <div id="loadingText" style="display: ${ResultsWidget.loading ? 'flex' : 'none'};width:fit-content;align-items: center;flex-grow:1;" >
                Chargement en cours...
            </div>
        `;
    }

    static updateResultSizeMgrHtml() {
        const displaySize = ResultsWidget.displaySize;
        ResultsWidget.controller.removeEventListener('click', 'result-size2');
        ResultsWidget.controller.removeEventListener('click', 'result-size3');
        $('#result-size-mgr').html(ResultsWidget.getResultSizeMgrHtml());
        setTimeout(() => {
            $(`#result-size${displaySize}`).addClass('active');
        });
    }

    static getResultSizeMgrHtml(): string {
        const displaySize = ResultsWidget.displaySize;
        setTimeout(() => {
            if (!ResultsWidget.controller) {
                return;
            }
            ResultsWidget.controller.addEventListener('click', () => {
                ResultsWidget.setDisplaySize(2);
                ResultsWidget.updateResultSizeMgrHtml();
            }, 'result-size2');
            ResultsWidget.controller.addEventListener('click', () => {
                ResultsWidget.setDisplaySize(3);
                ResultsWidget.updateResultSizeMgrHtml();
            }, 'result-size3');
        });
        return `
            <span id="result-size2" class="${displaySize === 2 ? 'active' : ''}"> 2L </span>
            <span> / </span>
            <span id="result-size3" class="${displaySize === 3 ? 'active' : ''}"> 3L </span>
         `;
    }

    static updateCheckboxToolsHtml(): void {
        if ($('#showUsed')[0]) ResultsWidget.controller.removeEventListener('change', 'showUsed');
        if ($('#displayGroups')[0]) ResultsWidget.controller.removeEventListener('change', 'displayGroups');
        let html = ResultsWidget.getUsedAssetsHtml() + ResultsWidget.getGroupsHtml();
        let container = document.getElementById('checkboxTools');
        if (!container) {
            return;
        }
        container.innerHTML = html;
    }

    static getUsedAssetsHtml(): string {
        setTimeout(() => {
            if (!$('#showUsed')[0]) return;
            $('#showUsed').prop('checked', ResultsWidget.showUsed());
            ResultsWidget.controller.addEventListener('change', () => {
                let value = $('#showUsed').is(':checked');
                ResultsWidget.showUsed(value);
                ResultsWidget.showUsedUpdated(true);
            }, 'showUsed');
        });
        return `
        ${ResultsWidget.tabId() !== 'style' ? `
            <div style="width:fit-content; height:fit-content;">
                <input id="showUsed" type="checkbox" style="0 !important"></input>
                <label for="showUsed" style="margin-bottom: 0; font-weight: 400;padding: 2px 0 0 4px">Voir les assets utilisés</label>
            </div>
        ` : ''} 
        `;
    }

    static getGroupsHtml(): string {
        setTimeout(() => {
            if (!$('#displayGroups')[0]) return;
            $('#displayGroups').prop('checked', ResultsWidget.displayGroups());
            ResultsWidget.controller.addEventListener('change', () => {
                let value = $('#displayGroups').is(':checked');
                ResultsWidget.displayGroups(value);
                ResultsWidget.displayGroupsUpdated();
            }, 'displayGroups');
        });
        return `
        ${ResultsWidget.tabId() === 'style' ? `
            <div style="position: absolute; left: 20px; bottom: 0;">
                <input id="displayGroups" type="checkbox"></input>
                <label for="displayGroups" style="margin-bottom: 0; font-weight: 400;">Voir les groupes</label>
            </div>
        ` : ''}
        `;
    }
}

